import * as React from 'react';

import { IconProps } from '../Icon';

export const CompanyOutlineIcon = ({
  width,
  color,
}: IconProps): JSX.Element => {
  const DEFAULT_WIDTH = '18';
  const DEFAULT_COLOR = 'none';

  return (
    <svg
      aria-hidden="true"
      fill={color || DEFAULT_COLOR}
      height={width || DEFAULT_WIDTH}
      viewBox="0 0 24 24"
      width={width || DEFAULT_WIDTH}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path d="m15.75 3v19c0 .414-.336.75-.75.75h-12c-.464 0-.909-.184-1.237-.513-.329-.328-.513-.773-.513-1.237v-18c0-.464.184-.909.513-1.237.328-.329.773-.513 1.237-.513h11c.464 0 .909.184 1.237.513.329.328.513.773.513 1.237zm-1.5 0c0-.066-.026-.13-.073-.177s-.111-.073-.177-.073h-11c-.066 0-.13.026-.177.073s-.073.111-.073.177v18c0 .066.026.13.073.177s.111.073.177.073h11.25z" />
        <path d="m11.75 15.5v6.5c0 .414-.336.75-.75.75h-5c-.414 0-.75-.336-.75-.75v-6.5c0-.332.132-.649.366-.884.235-.234.553-.366.884-.366h4c.331 0 .649.132.884.366.234.235.366.552.366.884zm-5 .25v5.5h3.5v-5.5z" />
        <path d="m22.75 9v12c0 .967-.784 1.75-1.75 1.75h-6c-.414 0-.75-.336-.75-.75v-14c0-.414.336-.75.75-.75h6c.966 0 1.75.783 1.75 1.75zm-1.5 0c0-.138-.112-.25-.25-.25h-5.25v12.5h5.25c.138 0 .25-.112.25-.25z" />
        <path d="m4.75 4.5h1.5v1.5h-1.5z" />
        <path d="m4.75 8h1.5v1.5h-1.5z" />
        <path d="m4.75 11.5h1.5v1.5h-1.5z" />
        <path d="m7.75 4.5h1.5v1.5h-1.5z" />
        <path d="m7.75 8h1.5v1.5h-1.5z" />
        <path d="m7.75 11.5h1.5v1.5h-1.5z" />
        <path d="m10.75 4.5h1.5v1.5h-1.5z" />
        <path d="m17.75 10.75h1.5v1.5h-1.5z" />
        <path d="m17.75 14.25h1.5v1.5h-1.5z" />
        <path d="m17.75 17.75h1.5v1.5h-1.5z" />
        <path d="m10.75 8h1.5v1.5h-1.5z" />
        <path d="m10.75 11.5h1.5v1.5h-1.5z" />
      </g>
    </svg>
  );
};
